import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const geographyApi = createApi({
  reducerPath: 'geographyApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Jurisdictions'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getJurisdictions: builder.query({
      query: () => ({
        url: '/v2/alert/jurisdictions',
      }),
      transformResponse: (response) => response.result,
      providesTags: ['Jurisdictions'], // Tells RTK Query this query provides 'Jurisdictions' data and to refetch when invalidated
    }),
    getJurisdictionByPlaceId: builder.query({
      query: (placeId) => ({
        url: `/v2/alert/jurisdiction/by-place-id/${encodeURIComponent(placeId)}`,
      }),
      transformResponse: (response) => {
        const jurisdiction = response?.result;
        if (!jurisdiction) return null;
        return { ...jurisdiction, name: jurisdiction.NAME ?? jurisdiction.name ?? '' };
      },
    }),
  }),
});

export const { useGetJurisdictionsQuery, useLazyGetJurisdictionByPlaceIdQuery } = geographyApi;
